module.exports = __webpack_public_path__ + "img/a_my_order2.155a73bb.png";